/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnShared } from './en-shared';
 /**
 *
 *
 * @export
 * @interface UpdateProtocolDto
 */
export interface UpdateProtocolDto {

    /**
     * @type {string}
     * @memberof UpdateProtocolDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof UpdateProtocolDto
     */
    description?: string | null;

    /**
     * @type {EnShared}
     * @memberof UpdateProtocolDto
     */
    shared?: EnShared;
}
